import React from 'react';
import './Jumbotron.scss';

export default ({ headline, body, footer, className="", ...otherProps }) => (
  <div className={`mpk-jumbotron ${className}`} {...otherProps}>
    {headline ? <div className="headline">{headline}</div> : null}
    {body ? <div className="body mpk-body">{body}</div> : null}
    {footer ? <div className="footer">{footer}</div> : null}
  </div>
)